import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

import { CustomerPortalMilestoneStepStatus } from "../../../../../../../util/enums";
import { SimpleBadge, SimpleBadgeProps } from "./SimpleBadge";

export const BadgeStatusByAction = (props: SimpleBadgeProps) => {
  const { dataCy, value } = props;
  const { t: translate } = useTranslation();

  switch (value) {
    case CustomerPortalMilestoneStepStatus.IN_PROGRESS:
      return (
        <SimpleBadge
          backgroundColor={colors.brandBlue50}
          dataCy={dataCy}
          textColor={colors.brandBlue500}
          value={translate("inProgress")}
        />
      );

    case CustomerPortalMilestoneStepStatus.CANCELLED:
    case CustomerPortalMilestoneStepStatus.REJECTED:
      return (
        <SimpleBadge
          backgroundColor={colors.error50}
          dataCy={dataCy}
          textColor={colors.error600}
          value={translate("cancelled")}
        />
      );

    case CustomerPortalMilestoneStepStatus.PENDING:
      return (
        <SimpleBadge
          backgroundColor={colors.gray50}
          dataCy={dataCy}
          textColor={colors.gray600}
          value={translate("waiting")}
        />
      );

    case CustomerPortalMilestoneStepStatus.COMPLETED:
    default:
      return (
        <SimpleBadge
          backgroundColor={colors.success50}
          dataCy={dataCy}
          textColor={colors.success600}
          value={translate("completed")}
        />
      );
  }
};
